import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import Horarios from "./components/Horarios";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Loader from "./components/Loader";
import PoliticaCancelamento from "./components/politicaCancelamento";

import "./styles/globals.css";

console.log(
  `%cDesenvolvido por Enzo Cipriani`,
  "color: #f7df1e; font-size: 14px; font-weight: bold;"
);
console.log(
  `%c📸 Instagram: %chttps://instagram.com/e.cipriani`,
  "color: #fff;",
  "color: #61dafb;"
);
console.log(
  `%c🔗 LinkedIn:  %chttps://linkedin.com/in/enzocipriani`,
  "color: #fff;",
  "color: #61dafb;"
);
console.log(
  `%c🌐 Site:      %chttps://e2tcode.com`,
  "color: #fff;",
  "color: #61dafb;"
);

function AppContent({ setAppLoading }) {
  const location = useLocation();

  React.useEffect(() => {
    // Se não estiver na rota principal, sempre tira o loader imediatamente
    if (location.pathname !== "/") {
      setAppLoading(false);
    }
  }, [location, setAppLoading]);

  return (
    <>
      <Header />
      <Routes>
        <Route
          path="/"
          element={<Horarios onLoaded={() => setAppLoading(false)} />}
        />
        <Route path="/politica-cancelamento" element={<PoliticaCancelamento />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  const [appLoading, setAppLoading] = useState(true);

  return (
    <Router>
      <div className="app-container">
        {appLoading && <Loader />}
        <AppContent setAppLoading={setAppLoading} />
      </div>
    </Router>
  );
}

export default App;
